'use strict';
var angular = require('angular');
var CredentialEditService = /** @class */ (function () {
    function CredentialEditService($http, $log, Auth) {
        'ngInject';
        this.$http = $http;
        this.$log = $log;
        this.Auth = Auth;
        // Object to store our user properties
        this.current = null;
    }
    CredentialEditService.prototype.handleSuccess = function (response) {
        return response;
    };
    CredentialEditService.prototype.handleError = function (response) {
        return response;
    };
    CredentialEditService.prototype.getDoctorTypes = function () {
        var request = this.$http.get('api/admin/doctortypes');
        return (request.then(this.handleSuccess, this.handleError));
    };
    CredentialEditService.prototype.deleteCredential = function (credentialId) {
        this.Auth.clearAccountCache();
        var self = this;
        return this.$http.delete('api/account/credentials/' + credentialId)
            .then(function success(response) {
            if (response.status == 200) {
                self.$log.debug('success response.....', response);
            }
            else {
                self.$log.error('api returned other than 200 response.....', response);
            }
            return response;
        }, function error(response) {
            self.$log.error('error response.....', response);
            return response;
        });
    };
    return CredentialEditService;
}());
export default CredentialEditService;
//# sourceMappingURL=credential-edit.service.js.map